import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { DataLakeFileModel, GetFileDirectoryFilesQuery, GetDataLakeFileInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_DIRECTORY_FILES = gql`
    query getFileDirectoryFiles($input: GetDataLakeFileInput!) {
        dataLakeFilesSearch (input: $input) {
            name
            path
            fileSize
            fileSizeBytes
            lastModifiedTime
            createdTime
        }    
    }
`;

export const queryFileDirectoryFiles = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileSearch: string
): Promise<DataLakeFileModel[] | undefined> => {
    const { data, errors } = await client.query<GetFileDirectoryFilesQuery>({
        variables: {
            input: {
                fileName: fileSearch,
                searchAllChildDirectories: true,
            } as GetDataLakeFileInput,
        },
        query: QUERY_DIRECTORY_FILES,
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    if (data?.dataLakeFilesSearch) {
        return data.dataLakeFilesSearch as DataLakeFileModel[];
    }
    return undefined;
};